import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export default function MondialRelayIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon viewBox={'0 0 32 32'} fontSize={'inherit'} {...props}>
      <path
        fill="#96154a"
        d="M27.659 1.46c-3.841-0.549-7.681-0.96-11.659-0.96s-7.819 0.411-11.659 0.96c-1.92 0.549-3.292 2.195-3.429 4.252v20.575c0.137 2.058 1.509 3.704 3.429 4.252 3.841 0.549 7.819 0.96 11.659 0.96 3.978-0.137 7.819-0.412 11.659-0.96 1.92-0.549 3.292-2.195 3.429-4.252v-20.575c-0.137-2.058-1.509-3.704-3.429-4.252z"
      ></path>
      <path
        fill="#fff"
        d="M9.965 18.606v7.819l4.115-2.606v-5.212c0-2.195 1.783-3.566 4.252-3.155v-3.841c-5.212-0.549-8.367 2.469-8.367 6.996zM14.628 9.965c1.235 0 2.332-1.097 2.332-2.332s-1.097-2.332-2.332-2.332c-1.235 0-2.332 1.097-2.332 2.332 0 0 0 0 0 0 0 1.372 1.097 2.332 2.332 2.332 0 0 0 0 0 0z"
      ></path>
      <path
        fill="#f6abb6"
        d="M19.292 15.177c0 0.274 0.274 0.549 0.549 0.549 0.549 0.137 1.097 0.137 1.646 0.137s1.097 0 1.646-0.137c0.274-0.137 0.412-0.274 0.549-0.549v-3.018c0-0.274-0.274-0.549-0.549-0.549-0.549-0.137-1.097-0.137-1.646-0.137s-1.097 0-1.646 0.137c-0.274 0.137-0.549 0.274-0.549 0.549v3.018z"
      ></path>
    </SvgIcon>
  );
}
